<template>
    <a class="button" :class="{ alert: isSet() }" @click.prevent="set" v-text="label"></a>
</template>
<script>
    import Cookie from './BaseCookie';
    export default {
        extends: Cookie,
        data() {
            return {
                buttonClass: {
                    'alert' : this.isSet
                }
            }
        },
        computed: {
            label() {
                return this.isSet() ? 'I DISAGREE' : 'I AGREE';
            }
        }
    }
</script>